"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseBranchFromApi = parseBranchFromApi;
function parseBranchFromApi(branch) {
    return {
        id: branch.id,
        name: branch.name,
        groupId: branch.groupID,
        ownerIds: branch.ownerIDs,
        employeeIds: branch.employeeIDs,
    };
}
